import PropTypes from 'prop-types';
import React from 'react';
import { Radio } from 'react-bootstrap';

const RadioAdapter = ({ input, label, meta, archived, ...rest }) => (
  <Radio {...input} title={label} {...rest}>
    <span className={archived ? 'text-muted' : ''}>{label}</span>
    <span className="checkmark"></span>
  </Radio>
);

RadioAdapter.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
};

export default RadioAdapter;
